<template>
	<div>
		<div v-if="isactive" class="popo">
			<van-index-bar v-if="isactive" :index-list="indexlist">
				<div v-for="(item,index) in lists" :key="index">
					<van-index-anchor :index="index" />
					<van-cell :title="v" @click="swap(v)" v-for="(v,i) in lists[index]" :key="i" />
				</div>
			</van-index-bar>
			<div class="popupclose">
				<van-icon name="close" size="30" @click="isactive=false" />
			</div>
		</div>

		<van-row :gutter="15">
			<van-col :span="16">
				<input type="text" class="form-input-c" placeholder="填写小区名称" v-model="searchValue" @blur="blur" />
			</van-col>
			<van-col :span="8">
				<div class="xiaoqu" @click="isactive=true">
					选择小区
					<van-icon name="arrow-down" />
				</div>
			</van-col>
		</van-row>
	</div>
</template>

<script>
	import {
		Button,
		Icon,
		Row,
		Col,
		Tag,
		IndexBar,
		IndexAnchor,
		Cell,
		CellGroup,
		Popup
	} from "vant";

	export default {
		components: {
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Row.name]: Row,
			[Col.name]: Col,
			[Tag.name]: Tag,
			[IndexBar.name]: IndexBar,
			[IndexAnchor.name]: IndexAnchor,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Popup.name]: Popup
		},

		data() {
			return {
				isactive: false,
				data: this.lists,
				searchValue: "",
				indexlist: [],
				scroll: 0
			};
		},
		props: {
			lists: Object,
			initValue: String
		},
 
		mounted() {
			this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
		},
		created() {
			this.searchValue = this.initValue
		},
		watch: {
			'initValue': {
				handler: function(newVal, oldVal) {
					console.log(newVal, oldVal)
					this.searchValue = this.initValue
				},
				deep: true 
			}, 
			lists: function() {
				this.indexlist = Object.keys(this.lists);
				console.log(this.indexlist);
			}
		},
		methods: {
			swap(value) {
				this.isactive = false;
				this.searchValue = value;
				document.documentElement.scrollTop = this.scroll;
				window.pageYOffset = this.scroll;
				document.body.scrollTop = this.scroll;
				this.$emit("change", value);
			},
			blur() {
				this.$emit("change", this.searchValue);
			}
		}
	};
</script>

<style scoped>
	.popo {
		position: absolute;
		z-index: 3000;
		background-color: #fff;
		top: 0;
		width: 95vw;
		z-index: 1000;
	}

	.form-box-tag {
		background-color: #f8f8f8;
		line-height: 32px;
		text-align: center;
		color: #555;
		border-radius: 4px;
		cursor: pointer;
		margin-bottom: 10px;
	}

	.form-box-tag.active {
		background-color: #feefe9;

		color: #f56229;
	}

	.popupclose {
		position: fixed;
		text-align: center;
		bottom: 20px;
		width: 100%;
	}
</style>>